import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';
import TableCell from '@material-ui/core/TableCell';


const PhyStatus =  ({ssn,...props}) =>{
 
    let nssn =  (ssn)? ssn: ((props && props.record)? props.record.ssn :  null);
    console.log('nssn:' + nssn);

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'physicaldue',
        payload: { id: nssn}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    console.log(data);
    return (      
        <TableCell align="left">{(data && data.id === 1 ) ? <font color="red"><b>Physical due</b></font> : ''}</TableCell>
    )
}

export default PhyStatus
